import {v4 as uuidv4} from "uuid";
export default (params) => {
	return uuidv4();
};
